const requestFilterCommandNames = [
  'applyAddrBuilding',
  'applyAddrStreet',
  'applyAttachmentFilter',
  'applyBadWork',
  'applyChargeable',
  'applyCompany',
  'applyCreator',
  'applyDistrict',
  'applyExecuter',
  'applyExpiredOnly',
  'applyImmediate',
  'applyInternal',
  'applyIsOrder',
  'applyMethodCreatingRequest',
  'applyNotWarranty',
  'applyPaymentState',
  'applyPhone',
  'applyPossWarranty',
  'applyPrioritiesRequest',
  'applyRating',
  'applyRetry',
  'applyService',
  'applyStatus',
  'applySubservice',
  'applyWarranty',
  'applyWarrantyOrg',
  'applyWaiting',
  'applyWorker',
  'closeFilter',
  'fetchAcceptanceStatuses',
  'fetchCompanies',
  'fetchCreators',
  'fetchDistricts',
  'fetchExecuters',
  'fetchRequests',
  'fetchServices',
  'fetchStages',
  'fetchStatuses',
  'fetchWorkers',
  'resetFilter',
  'setAcceptanceStatusesFlatValue',
  'setAddrFlatValue',
  'setAddrFloorValue',
  'setAddrPorchValue',
  'setAddrTypeFlatValue',
  'setDateRange',
  'setDateRangeField',
  'setFlatValueByPorchFloor',
  'setRelatedToExpired',
  'setSavedFilter',
  'setStageCurrentFlatValue',
  'setStageFlatValue',
  'setValueCheckedStage',
  'applyClientName'
];

export const createRequestFilterCommands = (source) => {
  const missingCommands = requestFilterCommandNames.filter(
    (commandName) => typeof source?.[commandName] !== 'function'
  );

  if (missingCommands.length > 0) {
    throw new Error(
      `Request filter commands are missing: ${missingCommands.join(', ')}`
    );
  }

  return requestFilterCommandNames.reduce((commands, commandName) => {
    commands[commandName] = source[commandName];
    return commands;
  }, {});
};
